import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './contact.html',
  styleUrl: './contact.scss',
})
export class ContactComponent {
  form = {
    nombre: '',
    email: '',
    telefono: '',
    interes: '',
    mensaje: '',
  };

  intereses = [
    'Talleres de bienestar & creatividad',
    'Eventos privados',
    'Colaboraciones creativas',
    'Otra consulta',
  ];

  submitted = signal(false);
  error = signal(false);

  onSubmit() {
    // Placeholder: mark as submitted (backend to be wired later)
    if (!this.form.nombre || !this.form.email) {
      this.error.set(true);
      return;
    }
    this.error.set(false);
    this.submitted.set(true);
  }
}
